// @flow
import { default as layoutRenderers } from './layouts';
import { default as controlRenderers } from './controls';

const renderers = [...layoutRenderers, ...controlRenderers];

export default renderers;
